// src/pages/storePages/manageStore/ProductFormPage.js
import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ProductFormDialog from "./ProductFormDialog";

export default function ProductFormPage() {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const isEdit = Boolean(slug);
  const initialCategoryId = searchParams.get("category") || "";
  const returnTo = searchParams.get("returnTo") || "/manage-store";

  const [open, setOpen] = useState(false);
  const closedRef = useRef(false); // prevent double-navigation

  useEffect(() => {
    const t = setTimeout(() => setOpen(true), 0);
    return () => clearTimeout(t);
  }, []);

  const goBack = () => {
    if (closedRef.current) return;
    closedRef.current = true;
    setOpen(false);
    // small delay so the <dialog> close animation can finish
    setTimeout(() => navigate(returnTo, { replace: true }), 120);
  };

  return (
    <ProductFormDialog
      open={open}
      productSlug={isEdit ? slug : undefined}
      defaultCategoryId={initialCategoryId}
      onClose={goBack}
      onSaved={goBack}
    />
  );
}